import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

interface MainPanelLaneProps {
  children?: React.ReactNode
  maxWidth?: string
  style?: React.CSSProperties
}

const Lane = styled.div<{ $maxWidth?: string }>`
  display: flex;
  max-width: ${props => props.$maxWidth ?? 'none'};
  flex-grow: 1;
  flex-basis: 1000px;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f8fafc;
  border-radius: 4px;

  @media ${media.belowTablet} {
    flex-basis: auto;
    max-width: none;
    height: auto;
    min-height: 0;
    overflow: visible;
  }
`

export const MainPanelLane = ({
  children,
  maxWidth,
  style,
}: MainPanelLaneProps) => {
  return (
    <Lane $maxWidth={maxWidth} style={style}>
      {children}
    </Lane>
  )
}
